module.exports = __webpack_public_path__ + "img/allow_access.f777d715.png";